// extracted by mini-css-extract-plugin
module.exports = {"container":"Vignette__container__20GWH","vignette":"Vignette__vignette__ouoFz"};